import React from 'react';
import hostImage from '../images/all-star-feb-13-hosts-1536x768.JPG';

function Event1() {
  return (
    <div>
      {/* Event Hero */}
      <section className="event-hero">
        <div className="hero-content">
          <p className="hero-subtitle">Friday February 13, 2026</p>
          <div style={{display: 'flex', justifyContent: 'center', margin: '2rem 0'}}>
            <a href="https://www.eventbrite.com/e/allstar-game-weekend-kick-off-hosted-by-2chainz-g-herbo-cactus-jack-tickets-1982412611486?aff=oddtdtcreator" target="_blank" rel="noopener noreferrer">
              <img
                src={hostImage}
                alt="2Chainz & G-Herbo - All-Star Weekend Hosts"
                style={{maxWidth: '100%', height: 'auto', borderRadius: '8px', cursor: 'pointer'}}
              />
            </a>
          </div>
          <p className="hero-description" style={{textAlign: 'center'}}>
            <strong>NBA All-Star Game Weekend Kickoff Party</strong><br/>
            Hosted by 2 Chainz, G Herbo & Cactus Jack Records Takeover<br/><br/>

            Start NBA All-Star Game Weekend the right way at the official kickoff party bringing together hip-hop, culture, and high-energy nightlife.<br/><br/>

            Join us for an unforgettable night featuring 2 Chainz, G Herbo, and a Cactus Jack Records takeover, setting the tone for the entire All-Star Weekend. Expect nonstop vibes, live DJ sets, celebrity energy, and a packed crowd ready to celebrate basketball's biggest weekend.<br/><br/>

            This is not just a party — it's the launchpad for All-Star Weekend.<br/><br/>

            <strong>EVENT HIGHLIGHTS</strong><br/>
            All-Star Weekend Kickoff Celebration<br/>
            Hosted by 2 Chainz & G Herbo<br/>
            Cactus Jack Records Takeover<br/>
            Top DJs, high-energy crowd, premium nightlife experience<br/>
            Early arrival strongly recommended<br/><br/>

            <strong>🎟️ TICKETS & ADMISSION</strong><br/>
            Early bird tickets (February 6-8):<br/>
            $30 Early Bird<br/>
            $50 VIP Skip-the-Line<br/><br/>

            Pricing (February 9-13):<br/>
            $50 General Admission<br/>
            $75 VIP Skip-the-Line<br/>
            VIP tickets provide expedited entry but do not include table seating.<br/><br/>

            <strong>🍾 TABLES & VIP EXPERIENCE</strong><br/>
            Table reservations offer the best experience with premium seating, bottle service, and personalized attention.<br/><br/>

            <strong>CONTACT & INQUIRIES</strong><br/>
            For table reservations, press/media, or general information, please contact:<br/>
            info@supremeteamla.com<br/><br/>

            This is the party everyone will be talking about all weekend. Secure your tickets early and kick off All-Star Weekend the right way.<br/><br/>

            21 and over age limit event
          </p>
        </div>
      </section>

      {/* Event Details */}
      {/* <section className="event-details">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Event Details</h2>
          </div>

          <div className="event-info-grid">
            <div className="info-box">
              <div className="info-label">Date & Time</div>
              <div className="info-value">Friday, February 13, 2026<br/>9:30 PM </div>
            </div>

            <div className="info-box">
              <div className="info-label">Duration</div>
              <div className="info-value">Approximately 60 minutes</div>
            </div>

            <div className="info-box">
              <div className="info-label">Participants</div>
              <div className="info-value">8 Elite Shooters</div>
            </div>

            <div className="info-box">
              <div className="info-label">Prize</div>
              <div className="info-value">$50,000 Winner</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* About Section */}
      <section className="section">
        <div className="container">
          {/* <div className="section-header">
            <h2 className="section-title">About The Contest</h2>
          </div> */}

          <div style={{maxWidth: '900px', margin: '0 auto'}}>
            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              The 3-Point Contest brings together the NBA's most lethal long-range shooters for an intense battle of accuracy and consistency. Each participant has 60 seconds to shoot as many basketballs as possible from five designated spots around the three-point arc.
            </p> */}

            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              With four standard balls worth one point each and one "money ball" worth two points at each rack, strategy becomes as important as shooting ability. Players must manage their time wisely while maintaining their shooting rhythm under the bright lights and roaring crowd.
            </p> */}

            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
              The top three scorers from the first round advance to the finals, where they compete for the championship and the bragging rights of being crowned the NBA's best three-point shooter.
            </p> */}

            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <a href="https://www.eventbrite.com/e/allstar-game-weekend-kick-off-hosted-by-2chainz-g-herbo-cactus-jack-tickets-1982412611486?aff=oddtdtcreator" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Get Tickets</a>
            </div>
          </div>
        </div>
      </section>

      {/* Competition Format */}
      {/* <section className="section" style={{background: 'var(--dark-gray)'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Competition Format</h2>
          </div>

          <div className="events-grid">
            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">01</span>
              <h3>First Round</h3>
              <p>
                All eight participants compete. Each shooter gets 60 seconds to shoot from five spots around the arc. Four regular balls (1 point) and one money ball (2 points) at each spot.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">02</span>
              <h3>Finals</h3>
              <p>
                The top three scorers advance to the final round using the same format. All scores reset, and the highest score in the finals determines the champion.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">03</span>
              <h3>Championship</h3>
              <p>
                The winner receives $50,000 and eternal bragging rights as the league's premier three-point shooter. This prestigious title cements their legacy among the NBA's greatest marksmen.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default Event1;
